// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list[data-v-4401aa66] {\n  background: transparent;\n}\n#title[data-v-4401aa66] {\n  background: #0a425e;\n  padding: 8px;\n  border-radius: 4px 4px 4px 4px;\n  border-bottom: 4px solid #ff8364;\n}\n", ""]);
// Exports
module.exports = exports;
